// extracted by mini-css-extract-plugin
export default {"openModalButton":"ProfileFormModal_openModalButton__Wurfd"};